export const quickFilterKeys = {
  all: () => ['QUICK_FILTERS'] as const,
};
